import React from 'react'

import { Field } from 'formik'

import { KeyEventUtil } from 'utils'

import { Form, Col } from '_zari/core'

const FechaInicioFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('date-reporteCobranzas-fechaFin', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FECHA INICIO' htmlFor='date-reporteCobranzas-fechaInicio' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaInicio'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              id='date-reporteCobranzas-fechaInicio'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaInicioFormGroup)
